import { redirect } from '@tanstack/react-router';
import {
  PORTFOLIO_SAVED_VIEW_BASE,
  PORTFOLIO_SURFACE_BASE,
} from '@/features/views/hooks/useViewSurfacePaths';
import {
  urlSegmentToVisualizationType,
  visualizationTypeToUrlSegment,
} from '@/features/visualizations/utils/visualizationTypeToUrlSegment';

type LegacyVisualizationsRedirectArgs = {
  params: { org: string; loopId: number; _splat?: string };
};

const toTypeSegment = (segment: string | undefined) => {
  const visualizationType = segment ? urlSegmentToVisualizationType(segment) : undefined;
  return visualizationType ? visualizationTypeToUrlSegment(visualizationType) : undefined;
};

export const redirectLegacyVisualizationsToPortfolio = ({
  params: { org, loopId, _splat },
}: LegacyVisualizationsRedirectArgs): never => {
  const [first, second, third] = _splat?.split('/').filter(Boolean) ?? [];
  const viewId = first === 'view' ? Number(second) : Number.NaN;

  if (Number.isInteger(viewId) && viewId > 0) {
    const typeSegment = toTypeSegment(third);
    throw redirect({
      to: typeSegment ? `${PORTFOLIO_SAVED_VIEW_BASE}/${typeSegment}` : PORTFOLIO_SAVED_VIEW_BASE,
      params: { org, loopId, viewId },
      search: true,
      replace: true,
    });
  }

  const typeSegment = (first === 'main' && toTypeSegment(second)) || 'table';
  throw redirect({
    to: `${PORTFOLIO_SURFACE_BASE}/${typeSegment}`,
    params: { org, loopId },
    search: true,
    replace: true,
  });
};
